import React from "react";
import PluginRegistry from "../../pluginsInfrastructure/PluginRegistry";
import {
  ComponentToBeRegistered,
  Placeholder,
  PlaceholderPlugin,
  SupportedPluginContentfulDataType,
} from "../../pluginsInfrastructure/PluginRegistryTypes";
import loadable from "@loadable/component";
import { productOptions } from "../pluginOwners";

export const ProductConfiguratorComponent: ComponentToBeRegistered<any> = {
  placeholder: Placeholder.ProductConfigurator,
  Component: loadable<any>(() => import("./components/ProductConfigurator")),
  name: "ProductOptionsProductConfigurator",
  enable: () => {
    return true;
  },
  dataNeeds: {
    contentful: {
      bulkOrderQuantity: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Bulk Order > Quantity",
      },
      quantity: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Quantity",
      },
      recommended: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "callout.Recommended",
      },
      outOfStockButtonAttribute: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page v2 > Out Of Stock",
      },
      newCalloutText: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "callout.New",
      },
      dropdownIncompatibleMessage: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Dropdown Incompatible Option Message",
      },
      selectorIncompatibleText: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Selector Incompatible Text",
      },
    },
  },
};

export const productConfigurator: PlaceholderPlugin = {
  init(pluginRegistry: PluginRegistry) {
    pluginRegistry.addComponent(this, ProductConfiguratorComponent);
  },
  pluginOwner: productOptions,
};
